import React from "react";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const caseStudies = [
  {
    title: "MTJ Clothing Store",
    image: "/assets/mtjBanner.png",
    link: "#",
  },
  {
    title: "Zeen Clothing Store",
    image: "/assets/zeenBanner.png",
    link: "#",
  },
  {
    title: "MTJ Clothing Store",
    image: "/assets/mtjBanner.png",
    link: "#",
  },
  {
    title: "Zeen Clothing Store",
    image: "/assets/zeenBanner.png",
    link: "#",
  },
];

const Section7 = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    // prevArrow: <CustomPrevArrow />,
    // nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="container-1280 py-10 md:py-[60px] xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto">
      <h2 className="mb-6 text-[26px] md:text-[30px] font-bold">Case Studies</h2>
      <div className="w-full mx-auto">
        <Slider {...settings}>
          {caseStudies.map((study, index) => (
            <div key={index} className="px-4">
              <div >
                <img
                  src={study.image} 
                  alt={study.title}
                  className="w-full h-auto rounded-lg"
                />
                <div className="flex items-center justify-between w-full mb-4">
                  <h3 className="mt-3 text-2xl font-medium">{study.title}</h3>
                  <Link
                    to={"/case-studies"}
                    className="inline-block w-auto mt-2 text-center text-red-500 transition border border-black rounded sm:py-2 sm:px-4 hover:bg-red-500 hover:text-white"
                  >
                    View Case Study
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>

    </section>
  );
};

export default Section7;
